import React from "react";
import classes from './taxon_link.module.css';

import type { Taxon } from "js/ebird/taxonomy"; // TODO: Make the ebird file the index of types

type Props = { taxon: Taxon }

const TaxonLink = ({ taxon }: Props) => {
  return <a className={classes.species} href={`#/bird?id=${taxon.taxonCode}`}>
    <span className={classes.common}>{taxon.commonName} </span>
    <span className={classes.scientific}><i>{taxon.scientificName}</i></span>
  </a>;
}

export default TaxonLink;
